export const wasFieldModified = (
  modifiedFields?: (string | number | symbol)[],
  field?: string
): boolean => Boolean(field && modifiedFields?.includes(field))
